const textFieldFormParamFreq = {
  name: 'Name',
  value: 'Value'
};

export default textFieldFormParamFreq;
